/* Warm nearby images after the visible hero is loaded. Keep original sources
   and sizes; closed drawers are hydrated separately on pointer/focus intent. */
(function () {
  var conn = navigator.connection;
  var limited = conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''));
  var observer;
  var seen = new WeakSet();

  function prime(img) {
    var src = img.getAttribute('data-ss-thumb-src');
    if (src && !img.getAttribute('src')) { img.fetchPriority = 'low'; img.src = src; }
    if (limited) return;
    if (img.loading !== 'lazy' || img.complete && img.naturalWidth) return;
    var w = img.getBoundingClientRect().width;
    if (w > 0 && /^auto/.test(img.getAttribute('sizes') || '')) img.sizes = Math.round(w) + 'px';
    img.fetchPriority = 'low';
    img.loading = 'eager';
  }

  function watch() {
    document.querySelectorAll('img[loading="lazy"], img[data-ss-thumb-src]').forEach(function (img) {
      if (seen.has(img)) return;
      seen.add(img);
      if (observer) observer.observe(img);
      else {
        var r = img.getBoundingClientRect();
        if (r.width && r.height && r.top < innerHeight + 400 && r.bottom > -400) prime(img);
      }
    });
  }

  function start() {
    var critical = Array.from(document.images).filter(function (img) {
      var r = img.getBoundingClientRect();
      return !img.complete && r.width * r.height > 4096 && r.top < innerHeight && r.bottom > 0 && r.left < innerWidth && r.right > 0;
    });
    Promise.all(critical.map(function (img) {
      return new Promise(function (resolve) {
        img.addEventListener('load', resolve, { once: true });
        img.addEventListener('error', resolve, { once: true });
        if (img.complete) resolve();
      });
    })).then(function () {
      if ('IntersectionObserver' in window) observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          prime(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '400px 0px' });
      document.dispatchEvent(new CustomEvent('ss:images-ready'));
      watch();
      var timer;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(watch, 100);
      }).observe(document.body, { childList: true, subtree: true });
    });
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start, { once: true });
})();
